/* eslint-disable no-case-declarations */
/* eslint-disable @typescript-eslint/no-explicit-any */

import { FC, useState, useEffect } from "react";
import { useStores } from "@/app/csr-src/models";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";

import { getEnv } from "@/app/csr-src/env";

import { Button } from "@mui/material";

import UKToast from "@/common-components-src/components/UKToast/index";

import GooglePaySvg from "@/assets/icons/pay/GooglePay.svg";

import Styles from "./btn.module.scss";

declare global {
  let google: any;
  // let window: any;
}

interface GooglePayProps {
  onSubmit: () => any; // 提单
  toOrderList: () => void; // 支付失败后的回调
  onLoadingResult: (data: any, closeLoading: () => void) => any;
}

const CANCEL_URL = "/profile/my-orders";

const GooglePay: FC<GooglePayProps> = observer((props) => {
  const { t } = useTranslation();
  const { checkoutStore } = useStores();
  const { currentPayInfo, setPayResult, payMethod } = checkoutStore;

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [paymentsClient, setPaymentsClient] = useState(null);

  // 关闭loading
  const closeLoading = () => {
    setLoading(false);
    checkoutStore.setSafetyLoading(false);
  };

  // 关闭loading
  const onPayError = () => {
    UKToast.show({
      content: t("common.message.networkError"), // 弹窗内容
      icon: "error", // 可选：success, fail, loading, warn, info，影响图标
    });
    closeLoading();
    props.toOrderList(); // 支付失败，跳转到订单列表
  };

  /**
   *
   * 提单，并唤起支付
   *
   */
  const handleSubmit = async () => {
    setLoading(true);
    checkoutStore.setSafetyLoading(true);

    // 提单接口在父组件中统一处理
    const res: any = await props.onSubmit();
    console.log(res, "submit response");

    // 如果提单成功，则唤起支付
    if (res.success) {
      try {
        const payload = JSON.parse(JSON.parse(res.data.payInfo).payload);
        console.log("Google pay payload: " + JSON.stringify(payload));

        // google pay 是否可用
        isReadyToPay(JSON.parse(JSON.stringify(payload)));
      } catch (error) {
        onPayError();
      }
      return;
    }

    closeLoading();
  };

  // 初始化Google pay
  const initGooglePayClient = () => {
    console.log(getEnv().GOOGLE_PAY_INIT_ENVIRONMENT, "getEnv().GOOGLE_PAY_INIT_ENVIRONMENT");
    try {
      const client = new (google as any).payments.api.PaymentsClient({
        environment: getEnv().GOOGLE_PAY_INIT_ENVIRONMENT,
      });
      setPaymentsClient(client);
    } catch (error) {
      console.log("Google pay client init error: ", error);
      setError(true); // 初始化失败
    }
  };

  // 检查是否可以支付
  const isReadyToPay = (paymentDataRequest: any) => {
    const isReadyToPayRequest = {
      apiVersion: paymentDataRequest.apiVersion,
      apiVersionMinor: paymentDataRequest.apiVersionMinor,
      allowedPaymentMethods: paymentDataRequest.allowedPaymentMethods,
    };
    (paymentsClient as any)
      .isReadyToPay(isReadyToPayRequest)
      .then(function (response: any) {
        if (response.result) {
          // 去支付
          console.log("Is ready to pay response: " + response);
          handlePayment(paymentDataRequest);
          return;
        }
        // 支付不可用，跳转订单列表 TODO: 在提单前校验，支付方式不可用，可切换其他支付方式使用
        onPayError();
      })
      .catch(function (err: any) {
        console.log("Is ready to pay error: " + err);
        onPayError(); // 不可支付跳转订单列表
      });
  };

  const handlePayment = (paymentDataRequest: any) => {
    (paymentsClient as any)
      .loadPaymentData(paymentDataRequest)
      .then(function (paymentData: any) {
        // 处理返回的支付数据
        console.log("Handle payment response: " + paymentData);
        // 发送支付数据到服务器进行验证和处理
        redirectResult(paymentData);
      })
      .catch(function (err: any) {
        // 处理错误, 跳转订单列表unpay
        console.error("Handle payment error: " + err);
        onPayError();
      });
  };

  // 后端redirect接口
  const redirectResult = async (paymentData: any) => {
    const requestData = {
      txnSeqno: (checkoutStore.payResult as any).id,
      txnScene: "Consumption",
      payMethod: Number(payMethod),
      urlParams: {
        payDataExt: JSON.stringify(paymentData),
      },
    };
    props.onLoadingResult(requestData, closeLoading);
  };

  // 加载Google pay sdk
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://pay.google.com/gp/p/js/pay.js";
    script.async = true;
    document.head.appendChild(script);

    script.onload = () => {
      initGooglePayClient();
    };
    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <>
      {/* 提单按钮 */}
      <Button
        fullWidth
        sx={{
          padding: "0px",
          "&.Mui-disabled": {
            opacity: 0.3,
            "&:hover": {
              opacity: "0.3 !important",
              backgroundColor: "#000000 !important",
            },
            "&:active": {
              opacity: "0.3 !important",
              backgroundColor: "#000000 !important",
            },
          },
        }}
        className={Styles.commonGoogleBtn}
        disabled={loading || checkoutStore.submitOrderBtnDisabled || error}
        onClick={handleSubmit}
      >
        <GooglePaySvg width={57} height={22} />
      </Button>
    </>
  );
});

export default GooglePay;
